import { required } from "./field-rules";

export default [
  {
    name: "branch",
    attrs: {
      type: "select",
      label: "Организация",
      required: true, // переопределяется
      items: [], // переопределяется
    },
    rules: [required]
  },
  {
    name: "login",
    attrs: {
      type: "text",
      label: "Логин",
      required: true
    },
    rules: [required]
  }
];
